export default __webpack_public_path__ + "img/76e2fdca5295b797285cfcd6a1653611.svg";